import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { READINESS_LABELS } from "../../../constants/automapFoundingDealerConstants";
import {
  fetchAdminDealerOnboarding,
  markDealerLaunchReady,
  updateAdminDealerChecklistItem,
} from "../../../services/automapFoundingDealerApi";
import { AdminDealerNav, DealerDetailNav } from "./dealerAdminShared";

export default function AdminDealerOnboardingPage() {
  const { dealerId } = useParams();
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    fetchAdminDealerOnboarding(dealerId)
      .then(setPayload)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, [dealerId]);

  const toggleItem = async (itemKey, currentStatus) => {
    const next = currentStatus === "completed" ? "pending" : "completed";
    await updateAdminDealerChecklistItem(dealerId, itemKey, { status: next });
    load();
  };

  const markReady = async () => {
    try {
      await markDealerLaunchReady(dealerId);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const items = payload?.checklist?.checklistItems || [];

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Onboarding"
        title="Checklist de onboarding"
        description={`Dealer ${dealerId}`}
      />
      <AdminDealerNav active="list" />
      <DealerDetailNav dealerId={dealerId} active="onboarding" />
      <main className="admin-console__main wrap">
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && payload ? (
          <>
            <div className="dashboard-summary-grid">
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Readiness</span>
                <strong>{payload.readinessScore ?? 0}/100</strong>
              </div>
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Estado</span>
                <strong>{READINESS_LABELS[payload.readinessLabel] || payload.readinessLabel}</strong>
              </div>
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Listings activos</span>
                <strong>{payload.metrics?.activeCount ?? 0}</strong>
              </div>
            </div>
            <section className="dealer-state-box">
              <h3>Checklist</h3>
              <ul className="dashboard-checklist">
                {items.map((item) => (
                  <li key={item.key}>
                    <label>
                      <input
                        type="checkbox"
                        checked={item.status === "completed"}
                        onChange={() => toggleItem(item.key, item.status)}
                      />
                      {item.title}
                      {item.required ? " *" : ""}
                    </label>
                  </li>
                ))}
              </ul>
            </section>
            {payload.blockers?.length ? (
              <section className="dealer-state-box">
                <h3>Blockers abiertos</h3>
                <ul>
                  {payload.blockers.map((b) => (
                    <li key={b.id}>
                      [{b.severity}] {b.blockerType}: {b.description}
                    </li>
                  ))}
                </ul>
              </section>
            ) : null}
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <button type="button" className="dealer-portal-btn" onClick={markReady} disabled={!payload.launchReady}>
                Marcar launch-ready
              </button>
              <Link className="dealer-portal-btn" to={`/admin/dealers/${dealerId}/readiness`}>
                Ver readiness
              </Link>
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
